import { useTranslation } from 'react-i18next';
import { FormatDateValues } from '../models/FormatDateValues';
import DateVO from '../core/valueObjects/DateVO';

export const useDateLocalization = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === 'ua' ? 'uk' : i18n.language;

  const formatDate = (date: Date | string, format?: FormatDateValues) =>
    t('intlDateTime', {
      val: typeof date === 'string' ? DateVO.create(date).get() : date,
      formatParams: {
        val: format ? { locale, ...format } : { day: '2-digit', month: 'long', year: 'numeric', locale },
      },
    });
  return { formatDate };
};
